import { options } from '@carbon/charts/configuration';
import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';

export default {
  introduction: {
    title: <FormattedMessage {...messages.introTitle} />,
    copy: <FormattedMessage {...messages.introCopy} />,
    copy2: <FormattedMessage {...messages.introCopy2} />,
    button: <FormattedMessage {...messages.introButton} />,
    imageSrc: 'images/AI-in-action.jpg',
    imageSrcMobile: 'images/AI-in-action.jpg',
  },
  sideBar: {
    qSideTitle: <FormattedMessage {...messages.qSideTitel} />,
    qSideDescription: <FormattedMessage {...messages.qSideDescription} />,
    qNextBtn: <FormattedMessage {...messages.nextButton} />,
  },
  questions: [
    {
      id: 'q1',
      questionNumber: 1,
      type: 'regular',
      title: <FormattedMessage {...messages.q1Title} />,
      subTitle: <FormattedMessage {...messages.q1subTitle} />,
      options: [
        {
          optionId: 'option-1-1',
          copy: <FormattedMessage {...messages.option1Q1} />,
          nextStep: 'q2',
          value: 0,
        },
        {
          optionId: 'option-1-2',
          copy: <FormattedMessage {...messages.option2Q1} />,
          nextStep: 'q2',
          value: 2,
        },
        {
          optionId: 'option-1-3',
          copy: <FormattedMessage {...messages.option3Q1} />,
          nextStep: 'q2',
          value: 6,
        },
        {
          optionId: 'option-1-4',
          copy: <FormattedMessage {...messages.option4Q1} />,
          nextStep: 'q2',
          value: 12.5,
        },
      ],
    },
    {
      id: 'q2',
      questionNumber: 2,
      type: 'regular',
      title: <FormattedMessage {...messages.q2Title} />,
      options: [
        {
          optionId: 'option-2-1',
          copy: <FormattedMessage {...messages.option1Q2} />,
          nextStep: 'q3',
          value: 0,
        },
        {
          optionId: 'option-2-2',
          copy: <FormattedMessage {...messages.option2Q2} />,
          nextStep: 'q3',
          value: 2,
        },
        {
          optionId: 'option-2-3',
          copy: <FormattedMessage {...messages.option3Q2} />,
          nextStep: 'q3',
          value: 6,
        },
        {
          optionId: 'option-2-4',
          copy: <FormattedMessage {...messages.option4Q2} />,
          nextStep: 'q3',
          value: 12.5,
        },
      ],
    },
    {
      id: 'q3',
      questionNumber: 3,
      type: 'table',
      title: <FormattedMessage {...messages.q3Title} />,
      degree: [
        {
          copy: <FormattedMessage {...messages.degree0Q3} />,
          value: 0.0001,
          degreeId: 'degree-3-1',
        },
        {
          copy: <FormattedMessage {...messages.degree1Q3} />,
          value: 0,
          degreeId: 'degree-3-1',
        },
        {
          copy: <FormattedMessage {...messages.degree2Q3} />,
          value: 2,
          degreeId: 'degree-3-1',
        },
        {
          copy: <FormattedMessage {...messages.degree3Q3} />,
          value: 6,
          degreeId: 'degree-3-1',
        },
        {
          copy: <FormattedMessage {...messages.degree4Q3} />,
          value: 12.5,
          degreeId: 'degree-3-1',
        },
      ],
      options: [
        {
          optionId: 'option-3-1',
          copy: <FormattedMessage {...messages.option1Q3} />,
          nextStep: 'q4',
          value: 0.2,
        },
        {
          optionId: 'option-3-2',
          copy: <FormattedMessage {...messages.option2Q3} />,
          nextStep: 'q4',
          value: 0.2,
        },
        {
          optionId: 'option-3-3',
          copy: <FormattedMessage {...messages.option3Q3} />,
          nextStep: 'q4',
          value: 0.2,
        },
        {
          optionId: 'option-3-4',
          copy: <FormattedMessage {...messages.option4Q3} />,
          nextStep: 'q4',
          value: 0.2,
        },
        {
          optionId: 'option-3-5',
          copy: <FormattedMessage {...messages.option5Q3} />,
          nextStep: 'q4',
          value: 0.2,
        },
      ],
    },
    {
      id: 'q4',
      questionNumber: 4,
      type: 'multiOption',
      title: <FormattedMessage {...messages.q4Title} />,
      subTitle: <FormattedMessage {...messages.q4subTitle} />,
      options: [
        {
          optionId: 'option-4-1',
          copy: <FormattedMessage {...messages.option1Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-2',
          copy: <FormattedMessage {...messages.option2Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-3',
          copy: <FormattedMessage {...messages.option3Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-4',
          copy: <FormattedMessage {...messages.option4Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-5',
          copy: <FormattedMessage {...messages.option5Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-6',
          copy: <FormattedMessage {...messages.option6Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-7',
          copy: <FormattedMessage {...messages.option7Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-8',
          copy: <FormattedMessage {...messages.option8Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-9',
          copy: <FormattedMessage {...messages.option9Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-10',
          copy: <FormattedMessage {...messages.option10Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-11',
          copy: <FormattedMessage {...messages.option11Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-12',
          copy: <FormattedMessage {...messages.option12Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-13',
          copy: <FormattedMessage {...messages.option13Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-14',
          copy: <FormattedMessage {...messages.option14Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-15',
          copy: <FormattedMessage {...messages.option15Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
        {
          optionId: 'option-4-16',
          copy: <FormattedMessage {...messages.option16Q4} />,
          nextStep: 'q3',
          value: 0.2,
        },
      ],
    },
    {
      id: 'q5',
      questionNumber: 5,
      type: 'dinamicTable',
      title: <FormattedMessage {...messages.q5Title} />,
      nextStep: 'q5',
      degree: [
        {
          copy: <FormattedMessage {...messages.degree0Q5} />,
          value: 0.0001,
          degreeId: 'degree-5-0',
        },
        {
          copy: <FormattedMessage {...messages.degree1Q5} />,
          value: 0,
          degreeId: 'degree-5-1',
        },
        {
          copy: <FormattedMessage {...messages.degree2Q5} />,
          value: 1,
          degreeId: 'degree-5-2',
        },
        {
          copy: <FormattedMessage {...messages.degree3Q5} />,
          value: 4,
          degreeId: 'degree-5-3',
        },
        {
          copy: <FormattedMessage {...messages.degree4Q5} />,
          value: 9,
          degreeId: 'degree-5-4',
        },
        {
          copy: <FormattedMessage {...messages.degree5Q5} />,
          value: 12.5,
          degreeId: 'degree-5-5',
        },
      ],
      options: [
        {
          optionId: 'option-5-1',
          copy: <FormattedMessage {...messages.option1Q5} />,
          value: 0.2,
        },
        {
          optionId: 'option-5-2',
          copy: <FormattedMessage {...messages.option2Q5} />,
          value: 0.2,
        },
        {
          optionId: 'option-5-3',
          copy: <FormattedMessage {...messages.option3Q5} />,
          value: 0.2,
        },
        {
          optionId: 'option-5-4',
          copy: <FormattedMessage {...messages.option4Q5} />,
          value: 0.2,
        },
        {
          optionId: 'option-5-5',
          copy: <FormattedMessage {...messages.option5Q5} />,
          value: 0.2,
        },
      ],
    },
    {
      id: 'q6',
      questionNumber: 6,
      type: 'regular',
      subTitle: <FormattedMessage {...messages.q6Statement} />,
      title: <FormattedMessage {...messages.q6Title} />,
      options: [
        {
          optionId: 'option-6-1',
          copy: <FormattedMessage {...messages.option1Q6} />,
          nextStep: 'q6',
          value: 0,
        },
        {
          optionId: 'option-6-2',
          copy: <FormattedMessage {...messages.option2Q6} />,
          nextStep: 'q6',
          value: 2,
        },
        {
          optionId: 'option-6-3',
          copy: <FormattedMessage {...messages.option3Q6} />,
          nextStep: 'q6',
          value: 6,
        },
        {
          optionId: 'option-6-4',
          copy: <FormattedMessage {...messages.option4Q6} />,
          nextStep: 'q6',
          value: 12.5,
        },
      ],
    },
    {
      id: 'q7',
      questionNumber: 7,
      subTitle: <FormattedMessage {...messages.q7Statement} />,
      type: 'regular',
      title: <FormattedMessage {...messages.q7Title} />,
      options: [
        {
          optionId: 'option-7-1',
          copy: <FormattedMessage {...messages.option1Q7} />,
          nextStep: 'q7',
          value: 0,
        },
        {
          optionId: 'option-7-2',
          copy: <FormattedMessage {...messages.option2Q7} />,
          nextStep: 'q7',
          value: 2,
        },
        {
          optionId: 'option-7-3',
          copy: <FormattedMessage {...messages.option3Q7} />,
          nextStep: 'q7',
          value: 6,
        },
        {
          optionId: 'option-7-4',
          copy: <FormattedMessage {...messages.option4Q7} />,
          nextStep: 'q7',
          value: 12.5,
        },
      ],
    },
    {
      id: 'q8',
      questionNumber: 8,
      subTitle: <FormattedMessage {...messages.q8Statement} />,
      type: 'regular',
      title: <FormattedMessage {...messages.q8Title} />,
      options: [
        {
          optionId: 'option-8-1',
          copy: <FormattedMessage {...messages.option1Q8} />,
          nextStep: 'q8',
          value: 0,
        },
        {
          optionId: 'option-8-2',
          copy: <FormattedMessage {...messages.option2Q8} />,
          nextStep: 'q8',
          value: 2,
        },
        {
          optionId: 'option-8-3',
          copy: <FormattedMessage {...messages.option3Q8} />,
          nextStep: 'q8',
          value: 6,
        },
        {
          optionId: 'option-8-4',
          copy: <FormattedMessage {...messages.option4Q8} />,
          nextStep: 'q8',
          value: 12.5,
        },
      ],
    },
    {
      id: 'q9',
      questionNumber: 9,
      type: 'regular',
      title: <FormattedMessage {...messages.q9Title} />,
      options: [
        {
          optionId: 'option-9-1',
          copy: <FormattedMessage {...messages.option1Q9} />,
          nextStep: 'q9',
          value: 0,
        },
        {
          optionId: 'option-9-2',
          copy: <FormattedMessage {...messages.option2Q9} />,
          nextStep: 'q9',
          value: 2,
        },
        {
          optionId: 'option-9-3',
          copy: <FormattedMessage {...messages.option3Q9} />,
          nextStep: 'q9',
          value: 6,
        },
        {
          optionId: 'option-9-4',
          copy: <FormattedMessage {...messages.option4Q9} />,
          nextStep: 'q9',
          value: 12.5,
        },
      ],
    },
  ],
  results: {
    resultsTitleLearner: <FormattedMessage {...messages.resultsTitleLearner} />,
    resultsTitleLeader: <FormattedMessage {...messages.resultsTitleLeader} />,
    resultsSubTitleLeader: (
      <FormattedMessage {...messages.resultsSubTitleLeader} />
    ),
    resultsSubTitleLearner: (
      <FormattedMessage {...messages.resultsSubTitleLearner} />
    ),
    resultsTextLeader: <FormattedMessage {...messages.resultsTextLeader} />,
    resultsTextLearner: <FormattedMessage {...messages.resultsTextLearner} />,
    resultsDownloadBtn: <FormattedMessage {...messages.resultsDownloadBtn} />,
    resultsRestartBtn: <FormattedMessage {...messages.resultsRestartBtn} />,
    imageSrc: 'images/AI-in-action.jpg',
    resultLeaderTips: [
      <FormattedMessage {...messages.resultsLeaderTip1} />,
      <FormattedMessage {...messages.resultsLeaderTip2} />,
      <FormattedMessage {...messages.resultsLeaderTip3} />,
      <FormattedMessage {...messages.resultsLeaderTip4} />,
      <FormattedMessage {...messages.resultsLeaderTip5} />,
    ],
    resultLearnerTips: [
      <FormattedMessage {...messages.resultsLearnerTip1} />,
      <FormattedMessage {...messages.resultsLearnerTip2} />,
      <FormattedMessage {...messages.resultsLearnerTip3} />,
      <FormattedMessage {...messages.resultsLearnerTip4} />,
    ],
    resultsFinalMsgLearner: (
      <FormattedMessage {...messages.resultsFinalMsgLearner} />
    ),
    resultsFinalMsgLeader: (
      <FormattedMessage {...messages.resultsFinalMsgLeader} />
    ),
    retryBtn: <FormattedMessage {...messages.retryBtn} />,
    imageSrcMobile: 'images/AI-in-action.jpg',
  },
};
